import React from 'react'

export default function NoClientFound() {
  return (
    <div className="blank__table__state">
      No clients found for this criteria. Please broaden or change your search criteria and filters
    </div>
  )
}
